/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

const TITLES = {
  EDIT: "Edit",
  ADD: "Add",
  CLONE: "Clone",
  DELETE: "Delete",
  ADD_REALM: "Add Realm",
  REALM_NAME: "Realm Name",
};

const MESSAGES = {
  REALM_TITLE: "Realms",
  SELECT_REALM: "Select Realm",
  REALM_EMPTY_SCREEN_TITLE: "No Realm to display",
  REALM_ADD_BUTTON: "Add Realm",
  NO_RESULTS_FOUND: "No Results Found",
  PLEASE_TRY_A_DIFFERENT_REALM: "Please Try a Different Realm",
};

export const PAGE_SIZE_REALMS = 1000;

export { TITLES, MESSAGES };
